import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({
  title = "Mangoloops - Responsive Website Template",
  description = "We provide web development and digital marketing services in Mumbai.",
  keywords = "",
  author = "Mangoloops",
  canonical = "https://mangoloops.com/",
  robots = "index, follow",
  ogTitle = "Best Web Development Company",
  ogDescription = "Top services in Surat",
  ogImage = "https://yourwebsite.com/image.jpg",
  ogUrl = "https://mangoloops.com/",
  ogType = "website",
  twitterCard = "summary_large_image",
  twitterTitle = "Best Web Development Company",
  twitterDescription = "Top services in Surat",
  twitterImage = "https://mangoloops.com/image.jpg",
}) => {
  return (
    <Helmet>
      {/* Standard metadata tags */}
      <title>{title}</title>
      <meta name="title" content={title} />
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="author" content={author} />
      <meta name="robots" content={robots} />
      <link rel="canonical" href={canonical} />

      {/* Open Graph tags */}
      <meta property="og:title" content={ogTitle || title} />
      <meta property="og:description" content={ogDescription || description} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:url" content={ogUrl} />
      <meta property="og:type" content={ogType} />

      {/* Twitter Card tags */}
      <meta name="twitter:card" content={twitterCard} />
      <meta name="twitter:title" content={twitterTitle || title} />
      <meta name="twitter:description" content={twitterDescription || description} />
      <meta name="twitter:image" content={twitterImage} />
    </Helmet>
  );
};

export default SEO;
